import providerGroupService from '../services/providerGroup.service';

const providerGroups = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, model) {
            return providerGroupService.create(model);
        },

        //READ
        get(_, params) {
            return providerGroupService.get(params.id, params.urlParameters, params.requestId);
        },
        getlist() {
            return providerGroupService.getlist();
        },

        //UPDATE
        update(_, model) {
            return providerGroupService.update(model);
        },

        //DELETE
        delete(_, id) {
            return providerGroupService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default providerGroups;
